import React, { useState, useEffect } from 'react';
import { GetRequest } from 'components/common/index.js';
import MaterialsSection from 'components/quote_builder_widget/shared/MaterialsSection';
import HotStampingMachinesSection from 'components/quote_builder_widget/sections/HotStampingMachinesSection';
import HotStampingPrintingBlockSection from 'components/quote_builder_widget/sections/HotStampingPrintingBlockSection';
import SectionMenuLayout, { activeSubsection } from 'components/quote_builder_widget/shared/SectionMenuLayout';
import styles from 'components/quote_builder_widget/settings/_style.module.scss';

// The widget settings' Yaldız tab: the hot stamping materials visitors choose from (each with the name they see), the
// hot stamping machines the widget prices on, and the one printing block (klişe) it prices with.
const HotStampingMaterialsSection = ({ onChange }) => (
  <MaterialsSection materialType="hot_stamping_material" translationPrefix="hot_stamping" onMaterialsChange={onChange} />
);

const HOT_STAMPING_SECTIONS = [
  { id: 'hot_stamping_materials', label: 'quote_builder_widget.hot_stamping_menu_materials', Content: HotStampingMaterialsSection },
  { id: 'hot_stamping_machines', label: 'quote_builder_widget.hot_stamping_menu_machines', Content: HotStampingMachinesSection },
  { id: 'hot_stamping_printing_block', label: 'quote_builder_widget.hot_stamping_menu_printing_block', Content: HotStampingPrintingBlockSection },
];

const HotStampingSection = ({ activeSection, onSectionChange, onChange }) => {
  const [addedCounts, setAddedCounts] = useState({});
  const active = activeSubsection(HOT_STAMPING_SECTIONS, activeSection);
  const { Content } = active;

  // Each menu entry counts what is added to the widget, whichever page is open (as the Materials tab's menu does).
  const fetchAddedCounts = () => {
    GetRequest({
      url: `/quote-builder/user_unit_prices/list/settings_list/hot_stamping_material/${window.locale || 'en'}`,
      callback: (materials) => {
        const count = materials.filter((material) => material.widget_enabled === 'true').length;
        setAddedCounts((previous) => ({ ...previous, hot_stamping_materials: count }));
      }
    });
    GetRequest({
      url: '/quote-builder/widgets/hot-stamping',
      callback: (data) => {
        const count = data.machines.filter((machine) => machine.widget_enabled).length;
        setAddedCounts((previous) => ({ ...previous, hot_stamping_machines: count }));
      }
    });
  };

  useEffect(fetchAddedCounts, []);

  const handleChange = () => {
    fetchAddedCounts();
    onChange();
  };

  return (
    <SectionMenuLayout
      label={t('quote_builder_widget.section_hot_stamping')}
      sections={HOT_STAMPING_SECTIONS.map((section) => ({ ...section, count: addedCounts[section.id] }))}
      activeId={active.id}
      onSectionChange={onSectionChange}
    >
      <div className={styles.fieldGroup}>
        <Content key={active.id} onChange={handleChange} />
      </div>
    </SectionMenuLayout>
  );
};

export default HotStampingSection;
